import { render, staticRenderFns } from "./drawer-user-add.vue?vue&type=template&id=2f8ea6c4&"
import script from "./drawer-user-add.vue?vue&type=script&lang=js&"
export * from "./drawer-user-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports